import http, { httpWithoutMiddleware } from '@/api/http'

import {
  PostAuthLocalLoginParams,
  PostAuthLocalLoginResponse,
  PostAuthRefreshResponse,
  PostAuthLogoutResponse,
  PostAuthKeycloakParams,
  PostAuthKeycloakResponse,
  GetAuthVerifyResponse,
} from './types'

export const postAuthLocalLogin = async (params: PostAuthLocalLoginParams) => {
  const response = await http.post<PostAuthLocalLoginResponse>(
    '/auth/login/dev/',
    params
  )

  return response.data
}

export const postAuthRefresh = async () => {
  const response = await httpWithoutMiddleware.post<PostAuthRefreshResponse>(
    '/auth/refresh/'
  )
  return response.data
}

export const postAuthLogout = async () => {
  const response = await http.post<PostAuthLogoutResponse>('/auth/logout/')
  return response.data
}

export const postAuthKeycloak = async (params: PostAuthKeycloakParams) => {
  const response = await http.post<PostAuthKeycloakResponse>(
    '/auth/login/',
    params
  )
  return response.data
}

export const getAuthVerify = async () => {
  const response = await http.get<GetAuthVerifyResponse>('/auth/verify/')
  return response.data
}
